import { Typography } from '@compass/components'

import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unset } from './MissingData'

export const tagColumn = () =>
  columnHelper.display({
    id: 'tag',
    header: 'Tag',
    cell: ({ row }) => {
      const tag = row.original.tags

      if (tag == null) {
        return <Unset />
      }

      return (
        <CellAction copyValue={JSON.stringify(tag)} field='tag' className='max-w-72 truncate'>
          <Typography className='text-nowrap' title={JSON.stringify(tag, null, 4)}>
            {JSON.stringify(tag)}
          </Typography>
        </CellAction>
      )
    },
  })
